import { render, staticRenderFns } from "./mentionsPage.vue?vue&type=template&id=25bfe24e&scoped=true"
import script from "./mentionsPage.vue?vue&type=script&lang=js"
export * from "./mentionsPage.vue?vue&type=script&lang=js"
import style0 from "./mentionsPage.vue?vue&type=style&index=0&id=25bfe24e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bfe24e",
  null
  
)

export default component.exports